import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "flex items-center text-gray-700" }
const _hoisted_4 = { class: "w-40 sm:w-52 truncate font-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (Array.isArray(_ctx.menuSubs) && _ctx.menuSubs.length)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        ref: "submenuRef",
        class: "max-h-0 overflow-hidden duration-500 transition-all",
        style: _normalizeStyle(_ctx.switchHeightStyle)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuSubs, (menuSub) => {
          return (_openBlock(), _createElementBlock("li", {
            key: menuSub.id
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.externalOrInternalLink(menuSub.url, menuSub.open)),
              class: _normalizeClass(`
          flex items-center pl-8 py-2 pr-4
          ${_ctx.validateUrl(menuSub.url) ? 'cursor-pointer hover:bg-gray-200' : ''}
          ${menuSub.url === _ctx.currentUrl ? 'bg-blue-200': ''}
          `)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_svg_icon, {
                  class: "w-5 mr-2",
                  path: menuSub.icon
                }, null, 8, ["path"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(menuSub.title), 1),
                  (_ctx.validateUrl(menuSub.url) === _ctx.LINK_STATUS.external)
                    ? (_openBlock(), _createBlock(_component_base_svg_icon, {
                        key: 0,
                        class: "w-4",
                        path: _ctx.mdiOpenInNew
                      }, null, 8, ["path"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 10, _hoisted_1)
          ]))
        }), 128))
      ], 4))
    : _createCommentVNode("", true)
}